export const c_menu__content_MaxHeight = {
  "name": "--pf-v6-c-menu__content--MaxHeight",
  "value": "18.75rem",
  "var": "var(--pf-v6-c-menu__content--MaxHeight)"
};
export default c_menu__content_MaxHeight;